
<div class="view-broadcasted-job-page" [ngClass]="cssClass" *ngIf="staffersAndShifts?.length">

<div class = "mont-bold small-font bottom-10 applicant-card" *ngIf = "hiredStaffers?.length">Hired:</div>
<div class="view-broadcasted-job-page" *ngIf="hiredStaffers.length">
  <ng-container *ngFor="let contractor of hiredStaffers">
      <div class="applicant-card">
        <div class = "contractor-detail-card bottom-20">
          <app-shift-detail-container [cssClass]="cssClass" [jobItem]="jobItem" [staffer] = "contractor" [userData] = "userData" [viewingHired]="true"></app-shift-detail-container> 
          <div class = "button-stack">
            <button class = "hire" *ngIf="previousShiftView" >
              <div class = "hire-txt">{{contractor.state}}</div>
            </button>
          </div>
        </div>
    </div>
  </ng-container>
</div>


<div class = "mont-bold small-font bottom-10 applicant-card" *ngIf = "pendingConfirmationStaffers?.length">Pending contractor confirmation:</div>
<div class="view-broadcasted-job-page" *ngIf="pendingConfirmationStaffers.length">
  <ng-container *ngFor="let contractor of pendingConfirmationStaffers">
      <div class="applicant-card">
        <div class = "contractor-detail-card bottom-20">
          <app-shift-detail-container [cssClass]="cssClass" [jobItem]="jobItem" [staffer] = "contractor" [userData] = "userData"></app-shift-detail-container> 
        </div>
    </div>
  </ng-container>
</div>


</div>
